import { get } from 'lodash';
import { call, put, take, fork } from 'redux-saga/effects';

import {
	GET_USER_ROLES,
	GET_USER_ROLES_SUCCESS,
	GET_USER_ROLES_ERROR,
} from '@/redux/ducks/userProfile/types';
import { SHOW_TOAST } from '@/redux/ducks/toast/types';
import { INIT_APP_ERROR } from '@/redux/ducks/init/types';
import api from '@/data';

export function* getRolesDesc(payload) {
	try {
		const response = yield call(api.getRolesList, payload);
		const userRolesData = get(response, 'data', []);
		yield put({
			type: GET_USER_ROLES_SUCCESS,
			data: userRolesData,
		});
	} catch (error) {
		if (error.status === 401) {
			yield put({ type: INIT_APP_ERROR, error: error.data });
		} else {
			yield put({ type: GET_USER_ROLES_ERROR, error: error.data });
			yield put({
				type: SHOW_TOAST,
				payload: {
					msg: `${get(error, 'data.message')}. Retry..`,
					type: 'error',
				},
			});
		}
	}
}

export function* getRolesDescWatcher() {
	while (true) {
		const { payload } = yield take(GET_USER_ROLES);
		yield fork(getRolesDesc, payload);
	}
}

function* userProfileSaga() {
	yield fork(getRolesDescWatcher);
}

export default userProfileSaga;
